import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';

import { FormControlName, FormGroup } from '@angular/forms';
import { ControlBase } from '../control';
import { RadioItem } from './radio-items';

@Component({
  selector: 'ds365-radio-group',
  template: `
    <div [formGroup]="group" [attr.id]="id">
      <div
        class="custom-control custom-radio form-check"
        *ngFor="let item of transfomredItems; let idx = index"
        [ngbTooltip]="item.title || ''"
        [ngClass]="{ 'form-check-inline': inline }"
      >
        <input
          type="radio"
          class="custom-control-input form-check-input"
          [name]="controlName"
          [value]="item.value"
          [attr.id]="item.value"
          [formControlName]="controlName"
          [attr.disabled]="item.disabled"
          ds365IsInvalid
        />
        <label class="custom-control-label form-check-label" 
               [ngClass]="{'disabled': item.disabled}" 
               [attr.for]="item.value" 
               [innerHTML]="item.label"> 
        </label>
      </div>
    </div>
  `,
  styles: [
    `
    label.disabled {
      color: #484848 !important;
    }
    
    .custom-radio .form-check-input {
      background-color: #ffffff !important;
      border-color: #43494e !important;
      position: relative;
    }
    
    .custom-radio .form-check-input:checked {
      background-color: #ffffff !important;
      border-color: #43494e !important;
    }

    .custom-radio .form-check-input:checked::before {
      content: '';
      display: block;
      width: 0.4em;
      height: 0.4em;
      background-color: #1A2430 !important;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    `
  ],
  standalone: false
})
export class RadioGroupComponent implements ControlBase, OnChanges {
  @Input() id;

  @Input() controlName: FormControlName;
  @Input() group: FormGroup;

  @Input() items: RadioItem[];
  @Input() optLabel = 'title';
  @Input() optValue = 'id';
  @Input() inline = false;
  @Input() value: any;

  public transfomredItems: RadioItem[];

  constructor(protected cd: ChangeDetectorRef) {}

  public ngOnChanges(changes: { [propertyName: string]: any }) {
    if (changes.hasOwnProperty('items')) {
      let clone: RadioItem[] = [];

      const currentValue = changes.items.currentValue;
      if (currentValue) {
        clone = currentValue.map((item: RadioItem) => ({
          label: item[this.optLabel],
          value: item[this.optValue],
          disabled: item.disabled,
          checked: item.checked || item[this.optValue] === this.value,
          title: item.title,
        }));
      }

      this.transfomredItems = this.markDefaultSelection(clone);
    }

    if (changes.hasOwnProperty('value') && this.items) {
      this.transfomredItems = this.markDefaultSelection(this.transfomredItems);
    }
  }

  private markDefaultSelection(items: RadioItem[]): RadioItem[] {
    // if (items.length > 0 && !items.find((o) => o.checked)) {
    //   this.group.get(this.controlName).setValue()
    // }
    if (this.value !== undefined) {
      items = items.map((item) => {
        item.checked = item.value === this.value;
        return item;
      });
    }

    return items;
  }
}